import { render, staticRenderFns } from "./noramlVerify.vue?vue&type=template&id=9f478aec&"
import script from "./noramlVerify.vue?vue&type=script&lang=js&"
export * from "./noramlVerify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports